import * as React from 'react';
import { injectIntl } from 'react-intl';
import { Grid } from 'semantic-ui-react';

import { ENDPOINTS_COMPETITIONS } from '../../../config/index';
import { localeData } from '../../../locales/data';
import { getLanguageCode } from '../../../shared/helpers';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import { Card } from '../../Card';
import { CardList } from '../../Card/CardList';
import { List } from '../../List';
import analytics from '../../../shared/services/analytics/analytics';

import { CompetitionsPropsGeneric } from './types';

const Competitions = ({ data, dataCompetitionsLevels, intl }: CompetitionsPropsGeneric) =>
  data.map((competition: any, index: any) => {
    if (competition && competition.get('status') === 'ACCEPTED') {
      const title = competition.get('name');

      const handleLeaderboardClick = () => {
        analytics.trackCustomEvent('dashboard_click_competition_leaderboard', { event_label: competition.get('id') });
      };

      const rank = competition.getIn(['leaderboard', 'rank']);
      const score = competition.getIn(['leaderboard', 'score']);
      const alphas = competition.getIn(['leaderboard', 'alphas']);
      const level = competition.getIn(['leaderboard', 'level']);
      const hasRank = !!rank;
      const hasScore = !!score;
      const levelIconSrc = (value: string) => `${ENDPOINTS_COMPETITIONS.competitionsLevels}/${value.toLowerCase().replace('_', '-')}/icon`;

      return (
        <Grid.Column tablet={8} mobile={16} computer={5} key={`${index}`}>
          <Card
            title={title}
            headerLink={`/competition/${competition.get('id')}`}
            headerLinkLabel={intl.formatMessage({
              id: 'dashboardMain.dashboardMiddleUpperRow.leaderboard',
              defaultMessage: localeData.en['dashboardMain.dashboardMiddleUpperRow.leaderboard'],
            })}
            onHeaderLinkClick={handleLeaderboardClick}
          >
            <List
              title={intl.formatMessage({
                id: 'dashboardMain.dashboardMiddleUpperRow.stats',
                defaultMessage: localeData.en['dashboardMain.dashboardMiddleUpperRow.stats'],
              })}
            >
              <CardList withContainer={false}>
                <CardList.Row>
                  <CardList.Cell>
                    <FormattedMessageHelper id="app.rank" />:
                  </CardList.Cell>
                  <CardList.Cell modifiers={['cap']}>
                    {hasRank ? rank.toLocaleString(getLanguageCode()) : <FormattedMessageHelper id="app.none" />}
                  </CardList.Cell>
                </CardList.Row>
                <CardList.Row>
                  <CardList.Cell modifiers={['cap']}>
                    <FormattedMessageHelper id="app.score" />:
                  </CardList.Cell>
                  <CardList.Cell>{hasScore ? score.toLocaleString(getLanguageCode()) : 0}</CardList.Cell>
                </CardList.Row>
                {typeof alphas === 'number' && (
                  <CardList.Row>
                    <CardList.Cell modifiers={['cap']}>
                      <FormattedMessageHelper id="app.alphas" />:
                    </CardList.Cell>
                    <CardList.Cell>{alphas.toLocaleString(getLanguageCode())}</CardList.Cell>
                  </CardList.Row>
                )}
                <CardList.Row>
                  <CardList.Cell>
                    <FormattedMessageHelper id="app.level" />:
                  </CardList.Cell>
                  <CardList.Cell modifiers={['level', 'cap', 'icon-text']}>
                    {level ? (
                      <>
                        <div className="card-list__item-icon-container">
                          <img className="card-list__item-icon" src={levelIconSrc(level)} />
                        </div>
                        {dataCompetitionsLevels.get(level)}
                      </>
                    ) : (
                      <>
                        <div className="card-list__item-icon-container">
                          <img className="card-list__item-icon" src={`${ENDPOINTS_COMPETITIONS.competitionsLevels}/none/icon`} />
                        </div>
                        {dataCompetitionsLevels.get('NONE')}
                      </>
                    )}
                  </CardList.Cell>
                </CardList.Row>
              </CardList>
            </List>
          </Card>
        </Grid.Column>
      );
    } else {
      return null;
    }
  });

export default injectIntl(Competitions);
